import { Button as MuiButton, Grid } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import { DateInput, TimeInput, required, useNotify } from "react-admin";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import RoomInput from "server/components/Fields/RoomInput";
import FormModal from "server/components/Modals/FormModal";

const pad = n => String(n).padStart(2, "0");

const toDateString = v => {
  if (!v) return null;
  if (typeof v === "string") return v.slice(0, 10);
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

const toTimeString = v => {
  if (!v) return null;
  if (typeof v === "string") {
    const iso = v.match(/T(\d{2}:\d{2})/);
    if (iso) return iso[1];
    if (/^\d{2}:\d{2}/.test(v)) return v.slice(0, 5);
  }
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : `${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

const LanguageScheduleDialog = ({ campaignId, languageId, exam, onSaved }) => {
  const notify = useNotify();

  const defaultValues = {
    examDate: exam?.examDate ? toDateString(exam.examDate) : null,
    examTime: exam?.examDate ? toTimeString(exam.examDate) : null,
    roomId: exam?.examRoomId ?? null,
  };

  const handleSave = async data => {
    const payload = {
      examDate: toDateString(data.examDate),
      examTime: toTimeString(data.examTime),
      roomId: data.roomId,
    };
    await dataProvider.customRequest(doctoralRequests.scheduleLanguageExam(campaignId, languageId), payload, "POST");
    notify("Изпитът по език е насрочен", { type: "success" });
    if (onSaved) onSaved();
  };

  return (
    <FormModal
      triggerButton={
        <MuiButton
          size="small"
          variant="outlined"
          startIcon={<EventIcon />}
          sx={{ whiteSpace: "nowrap", minWidth: "auto" }}
        >
          Насрочване на изпит
        </MuiButton>
      }
      titleContent="Насрочване на изпит по език"
      defaultValues={defaultValues}
      onConfirm={handleSave}
      saveTitle="Запази"
    >
      <Grid
        container
        spacing={2}
        sx={{ mt: 0 }}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <DateInput
            source="examDate"
            label="Дата на изпита"
            validate={required()}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <TimeInput
            source="examTime"
            label="Час на изпита"
            validate={required()}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <RoomInput
            source="roomId"
            label="Зала (място)"
            isRequired
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default LanguageScheduleDialog;
